// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.microsoft-signin-button {
  display: flex;
  height: 50px;
  align-items: center;
  background-color: #ffff;
  justify-content: center;
  width: 100%;
  border: 1px solid #929292;
  border-radius: 50px;
  color: #000000;
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.microsoft-logo {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.multi-colored-placeholder-container__text {
  position: absolute;
  left: 75px;
  transform: translateY(-125%);
  display: flex;
  pointer-events: none;
}

.multi-colored-placeholder-container__text--first {
  color: rgb(170, 170, 170);
}

.multi-colored-placeholder-container__text--second {
  color: rgb(209, 208, 208);
}
`, "",{"version":3,"sources":["webpack://./src/containers/loginPageCards/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".microsoft-signin-button {\n  display: flex;\n  height: 50px;\n  align-items: center;\n  background-color: #ffff;\n  justify-content: center;\n  width: 100%;\n  border: 1px solid #929292;\n  border-radius: 50px;\n  color: #000000;\n  padding: 10px 20px;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.microsoft-logo {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n}\n\n.multi-colored-placeholder-container__text {\n  position: absolute;\n  left: 75px;\n  transform: translateY(-125%);\n  display: flex;\n  pointer-events: none;\n}\n\n.multi-colored-placeholder-container__text--first {\n  color: rgb(170, 170, 170);\n}\n\n.multi-colored-placeholder-container__text--second {\n  color: rgb(209, 208, 208);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
